import { motion } from "framer-motion";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// Animation constants - extracted to prevent inline object recreation
const FADE_IN_UP = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6 }
};

// Font style constant
const PLAYFAIR_STYLE = { fontFamily: "'Playfair Display', serif" };

const VolunteerPage = () => {
  return (
    <div data-testid="volunteer-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets-7cd3h4nn.emergentagent.net/job_4bb091c1-e4be-474e-9067-19b51e555ba6/artifacts/0mdb2rzq_PXL_20260414_141047472~3.webp"
        alt="Volunteer - Murphy's Giving Market"
        objectPosition="top"
      />

      {/* Volunteer Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={FADE_IN_UP.initial}
            animate={FADE_IN_UP.animate}
            transition={FADE_IN_UP.transition}
          >
            <h1 
              data-testid="volunteer-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-8"
              style={PLAYFAIR_STYLE}
            >
              Volunteer
            </h1>
            
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8">
              <p className="text-lg text-[#333333] leading-relaxed">
                Our dedicated team of volunteers makes the work of Murphy's Giving Market possible. We need volunteers for various tasks 8:30am - 1:30pm on Mondays, Tuesdays, Fridays, Saturdays, and Sundays. All volunteers receive a manual and agree to a code of conduct. Contact us for schedules and shifts!
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default VolunteerPage;
